var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"not-found"},[_c('b-row',[_c('b-col',[_c('p',{staticClass:"code"},[_vm._v("404")]),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('notFound.text')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }